/* eslint-disable */
// This file is generated by dev/generateInitialLangFallback.ts. Do not edit it manually.

import type { LangPackStringValue } from '../../api/types';
import type { LangKey } from '../../types/language';

export default {
  "WrongNumber": "Número incorreto?",
  "SentAppCode": "Enviamos o código para o app **Telegram** no seu outro dispositivo.",
  "LoginJustSentSms": "Enviamos um código via SMS. Por favor, digite-o acima.",
  "LoginHeaderPassword": "Inserir Senha",
  "LoginEnterPasswordDescription": "Você ativou a Verificação em Duas Etapas e a sua conta está protegida com uma senha adicional.",
  "StartText": "Por favor, confirme o código do\nseu país e digite o seu\nnúmero de telefone.",
  "LoginPhonePlaceholder": "Seu número",
  "LoginNext": "Próximo",
  "LoginQRLogin": "Entrar com Código QR",
  "LoginQRTitle": "Entrar no Telegram com Código QR",
  "LoginQRHelp1": "Abra o Telegram no seu telefone",
  "LoginQRHelp2": "Abra **Configurações** > **Dispositivos** > **Adicionar Dispositivo**",
  "LoginQRHelp3": "Escaneie esta imagem para entrar",
  "LoginQRCancel": "Entrar com número de telefone",
  "LoginPasskey": "Entrar com Chave de Acesso",
  "YourName": "Seu Nome",
  "LoginRegisterDesc": "Digite seu nome e adicione uma foto.",
  "LoginRegisterFirstNamePlaceholder": "Nome",
  "LoginRegisterLastNamePlaceholder": "Sobrenome",
  "LoginSelectCountryTitle": "País",
  "CountryNone": "País não encontrado",
  "PleaseEnterPassword": "Digite a sua nova senha",
  "ErrorPhoneNumberInvalid": "Número de telefone inválido. Por favor, tente de novo",
  "ErrorCodeInvalid": "Código inválido. Por favor, tente de novo",
  "ErrorIncorrectPassword": "Senha inválida. Por favor, tente de novo",
  "ErrorPasswordFlood": "Muitas tentativas. Por favor, tente depois",
  "ErrorPhoneBanned": "Este número de telefone está banido",
  "ErrorFloodTime": "Muitas tentativas. Por favor, tente de novo em {time}",
  "ErrorUnexpected": "Erro inesperado",
  "ErrorUnexpectedMessage": "Erro inesperado: {error}"
} as Record<LangKey, LangPackStringValue>;
